import { createContext, useContext, useState, useEffect } from 'react';
import { getTranslations } from '../lib/api';

const LanguageContext = createContext();

const FALLBACK = {
    menu: "Menu", search: "Search our menu...", all: "All",
    loading: "Loading menu...", not_found: "Menu not found",
    not_found_desc: "The menu you're looking for doesn't exist or isn't published yet.",
    no_dishes: "No dishes found", ar_available: "AR Experience Available",
    ar_desc: "View this dish in your space using AR", about_dish: "About this dish",
    back_to_menu: "Back to Menu", share: "Share", powered_by: "Powered by",
    scan_to_view: "Scan to view our menu in AR", ingredients: "Ingredients"
};

export function LanguageProvider({ children }) {
    const [lang, setLang] = useState(() => localStorage.getItem('ar_menu_lang') || 'en');
    const [translations, setTranslations] = useState(FALLBACK);
    const [rtl, setRtl] = useState(false);

    useEffect(() => {
        localStorage.setItem('ar_menu_lang', lang);
        setRtl(lang === 'ar');
        getTranslations(lang)
            .then(res => setTranslations({ ...FALLBACK, ...res.data }))
            .catch(() => setTranslations(FALLBACK));
    }, [lang]);

    const t = (key) => translations[key] || key;

    return (
        <LanguageContext.Provider value={{ lang, setLang, t, rtl }}>
            {children}
        </LanguageContext.Provider>
    );
}

export const useLanguage = () => useContext(LanguageContext);
